import {useGameServerConnection} from '@glark-newco/game-library';
import {Button, Group} from '@mantine/core';
import {IconPlayerPlay} from '@tabler/icons-react';
import {StartTimerEvent, SupplyChainPayload} from '../SupplyChainPayloadTypes';

export function StartGameTimerButton() {
    const {publishPlayerAction} = useGameServerConnection<SupplyChainPayload>();

    function publishStartGameEvent() {
        publishPlayerAction({
            type: 'startTimerEvent',
            duration: 30, // minutes
        } as StartTimerEvent);
    }

    return (
        <Group
            data-testid="facilitator-actions"
            style={{
                width: '20%',
                position: 'absolute',
                pointerEvents: 'initial',
                right: '1rem',
                top: '7.75rem',
            }}
        >
            <Button
                rightSection={<IconPlayerPlay size={14}/>}
                radius={'xl'}
                variant="gradient"
                onClick={() => publishStartGameEvent()}
                gradient={{from: 'blue', to: 'teal', deg: 90}}
                size={'lg'} bd={'0.15em solid white'}
            >
                Start Game
            </Button>
        </Group>
    );
}